import fpApiUtil from "./fp-api-util";

const ANALYSIS = "factoryplan/analysis";

// 생산/판매/재고 상태(공장>스테이지>품목>인벤토리별 기초재고/생산/소비/기말재고 크로스탭, 비상세
// 버전) — AnalysisController#getPsiData(isDetail=false, 백엔드는 factoryplan/analysis/prod-sales-stock-status).
// 다른 크로스탭 화면과 같은 { crosstabHeader, chartHeader, data[].pivotData } 형태, measure
// (analysisIndicator: FP_BEGINNING_STOCK/FP_PRODUCTION/FP_CONSUMPTION/FP_ENDING_STOCK 4종 고정)가
// leaf 필드. `/detail` 변종(공급/소비 세부 지표까지 펼치는 버전)은 이 화면 범위 밖(비상세만 이관).
const getProdSalesStockStatuses = (params) => fpApiUtil.postParams(`${ANALYSIS}/prod-sales-stock-status`, params);

// 같은 엔드포인트의 차트용 호출 — 그리드에서 클릭한 행(plantCd/stageCd/itemCd/inventoryCd)으로
// 드릴다운, useGrouping:true로 그 레벨까지 백엔드가 집계해서 내려준다(ProdSalesStockStatusCrosstabDto
// .merge, GroupingLevel 참고, MaterialPsi와 동일 계열). 컬럼 필터(changes)는 1차 미이관이라 항상
// 빈 객체로 보낸다(fp-report-screen-guide.md §A-6e와 동일 결정).
const getProdSalesStockStatusChart = (params, changes) =>
  fpApiUtil.postFields(`${ANALYSIS}/prod-sales-stock-status`, { params, changes });

const fpProdSalesStockStatusService = { getProdSalesStockStatuses, getProdSalesStockStatusChart };
export default fpProdSalesStockStatusService;
